import { render, staticRenderFns } from "./PsAdministrationTransactionsList.vue?vue&type=template&id=ad45673a&scoped=true&"
import script from "./PsAdministrationTransactionsList.vue?vue&type=script&lang=js&"
export * from "./PsAdministrationTransactionsList.vue?vue&type=script&lang=js&"
import style0 from "./PsAdministrationTransactionsList.vue?vue&type=style&index=0&id=ad45673a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad45673a",
  null
  
)

export default component.exports